import React from 'react';
import PropTypes from 'prop-types';
import { Waiting } from '@jomaxx/react-async';
import styled from 'styled-components';
import Delay from '../shared/components/Delay';
import AsyncDelay from '../shared/components/AsyncDelay';
import { BootstrapStyles } from '../styles/spBootstrapExtended';
import { PageHeadStyles } from '../shared/components/PageHead';
import { SiteGlobalStyles } from '../styles';

const LoadingMessage = styled.div`
  text-align: center;
  max-width: 700px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
`;

export default function LayoutMain(props) {
  return (
    <React.Fragment>
      <BootstrapStyles />
      <SiteGlobalStyles />
      <PageHeadStyles />

      <Waiting>
        {waiting => (
          <div data-testid="root-layout">
            {props.alert}
            {props.navigation}

            <div className="main">
              {waiting && (
                <Delay ms={3000}>
                  <LoadingMessage className="container">
                    <h1>
                      We&apos;re working on it, but this is taking longer than
                      usual.
                    </h1>
                    <AsyncDelay ms={2000} />
                  </LoadingMessage>
                </Delay>
              )}

              <div id="content" hidden={waiting}>
                {props.content}
              </div>
            </div>

            {!waiting && props.footer}
          </div>
        )}
      </Waiting>
    </React.Fragment>
  );
}
LayoutMain.propTypes = {
  alert: PropTypes.node,
  navigation: PropTypes.node.isRequired,
  content: PropTypes.node,
  footer: PropTypes.node.isRequired,
};
